import React, { PureComponent } from 'react';
import { Platform, Text, TouchableOpacity, View } from 'react-native';
import Icon from "react-native-vector-icons/Ionicons";

class CheckBox extends PureComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    render() {
        const { checked, text, textStyle, containerStyle } = this.props;
        return (<TouchableOpacity style={containerStyle}
                onPress={this.props.onPress}>
                <View style={{flexDirection: 'row', alignItems: 'center'}}>
                <View style={{width: 20, height: 20, alignItems: 'center', justifyContent: 'center',
                              borderWidth: 2, borderColor: '#3ad07b',
                              backgroundColor: checked ? '#3ad07b' : 'transparent'}}>
                <Icon style={{
                    lineHeight: (Platform.OS === 'ios' ? 24 : undefined),
                    color: checked ? '#fff' : 'transparent',
                    fontSize: 32,
                }} name='ios-checkmark'/>
                </View>
                <Text style={textStyle || {marginLeft: 4}}>{text}</Text>
                </View>
                </TouchableOpacity>);
    }
};

export default CheckBox;
